import React,{Component} from 'react';
import {getMonthText, lastThreeMonths , getLast12Months} from './forms/lib/utils';
import {ressourcesList} from './forms/lib/liste-ressources';

class Recapitulation extends Component{
	state = {
		displayRecap : false,
		recapitulation_datas : {
				demandeur: {
					title: 'Mon profil',
					icon_img: './assets/img/step1.png',
					step: 1,
					available_datas: [],
					no_data: 'Aucune donnée saisie'
				},
				enfants: {
					title: 'Mes enfants a charge(s)',
					step: 2,
					icon_img: './assets/img/step2.png',
					available_datas: [],
					no_data: 'Aucune donnée saisie'
				},
				conjoint: {
					title: 'Conjoint(e)',
					step: 3,
					icon_img: './assets/img/step3.png',
					available_datas: [],
					no_data: 'Aucune donnée saisie'
				},
				logement: {
					title: 'Mon logement',
					step: 4,
					icon_img: './assets/img/step4.png',
					available_datas: [],
					no_data: 'Aucune donnée saisie'
				},
				ressources: {
					title: 'Ressources',
					step: 5,
					icon_img: './assets/img/step5.png',
					available_datas: [],
					no_data: 'Aucune ressources déclarée'
				}
			 },
	}

	get_nationalite_individu = (individu)=> {
		if (typeof individu.nationalite !== 'undefined') {
			let data_nat = '';
			switch (individu.nationalite) {
				case 'FR':
					data_nat = 'Française';
					break;
				case 'EEE - UE - Suisse':
					data_nat = 'EEE - UE - Suisse';
					break;
				case 'Hors UE':
					data_nat = 'Hors UE';
					break;
				default:
					data_nat = 'Francaise';
					break;
			}
			return <>Nationalit&eacute; <span className='bold'>	{data_nat }</span></>;
		}
		return '';
	}

	get_situation_individu = (individu)=> {
		let data_situation = '';
		if (typeof individu.activite !== 'undefined') {
			//
			switch (individu.activite) {
				case 'etudiant':
					data_situation = 'Etudiant(e)/Apprenti(e)';
					break;
				case 'chomeur':
					data_situation = 'Chômeur';
					break;
				case 'retraite':
					data_situation = 'Retraité(e)';
					break;
				default:
					break;
			}
			if (data_situation !== '') {
				data_situation = <span className="bold">{data_situation}</span>;
			}
		}
		return data_situation;
	}//

	get_statut_marital =	(famille , _conjoint , individu)=> {
		if (!famille.en_couple && typeof _conjoint !== 'undefined')
			return 'Célibataire';

		let data_statut_marital = '';
		if (typeof _conjoint !== 'undefined') {
			data_statut_marital = individu.statut_marital;
			switch (data_statut_marital) {
				case 'marie':
					data_statut_marital = 'Marié-e';
					break;
				case 'pacse':
					data_statut_marital = 'Pascé-e';
					break;
				case 'non_renseigne':
					data_statut_marital = 'En union libre';
					break;
				default:
					data_statut_marital = 'En union libre';
					break;
			}
		}
		return data_statut_marital;
	}

	map_ressources = function (id ) {
		const ressource = ressourcesList.find((r) => r.name === id);
		const mapRessources = {
			salaire_imposable: 'Salaire',
			ppa: 'Prime activite'
		};

		if (ressource) {
			return ressource.label;
		}

		if (mapRessources[id]) {
			return mapRessources[id];
		}

		return id;
	};
	add_ressource_to_recap = function ( ressources , ressources_personne , ress_id, thisMonth  ) {
		const currentDate = new Date();
		const currentMonth = currentDate.getMonth()+1;
		let previousMonthDate;
		if (currentMonth === 0) {
		  previousMonthDate = new Date(currentDate.getFullYear() - 1, 12, 1);
		} else {
		  previousMonthDate = new Date(currentDate.getFullYear(), currentMonth - 1, 1);
		}
		previousMonthDate =  previousMonthDate.toISOString().slice(0, 7);

		let ignore = ['salaire_net', 'salaire_de_base', 'retraite_brute', 'chomage_brut'];
		let rev_pro_non_salarie = [
				'tns_auto_entrepreneur_chiffre_affaires',
				'tns_benefice_exploitant_agricole',
				'tns_micro_entreprise_chiffre_affaires',
				'tns_autres_revenus'
		];
		
		if (!ignore.includes(ress_id)) {
			if (!rev_pro_non_salarie.includes(ress_id) && !ressources_personne[ress_id].details) {
				let ressource = ressources_personne[ress_id][previousMonthDate];

				ressource = ressource === null || typeof ressource === 'undefined' ? 0 : ressource;
				ressource = ressource % 1 === 0 ? ressource : ressource.toFixed(3);
				let data_ressource =<p className="ress_regular">
									{this.map_ressources(ress_id)}<span className='bold'> {ressource}€</span>
								</p>;

				if (ressource !== null && ressource > 0){
					ressources.push(data_ressource);
				} else {					
					data_ressource =<p className='month-ress'>
						{ this.map_ressources(ress_id)} ({getMonthText(previousMonthDate)}) <span className='bold'> {ressources_personne[ress_id][previousMonthDate]} €</span>
					</p>;
					ressources.push(data_ressource);
				}
			}else {

				const last12months = getLast12Months();
				const totalYear = last12months.reduce( (sum,dateString)=>{
					if ( dateString !== 'details' && dateString !== 'show'){
						let ressName = (ress_id ==='salaire_net') ? 'salaire_imposable' : ress_id; 

						return !isNaN(ressources_personne[ressName][dateString])
							? sum + ressources_personne[ressName][dateString]
							: sum;

					}
					return sum;
				},0);

				let data_ressource = <p className="ress_regular">
					{ this.map_ressources(ress_id)}(Total des 12 derniers mois )<span className='bold'> {Math.round(totalYear)}€</span>
				</p>;

				ressources.push(data_ressource);

			}
		}
	}

	showRecap = (e)=> {
		this.setState( ({displayRecap})=>{
			return {displayRecap : !displayRecap};
		})
	}

	hasData = ()=> {
		for ( const type_data in this.state.recapitulation_datas) {
			if (this.state.recapitulation_datas[type_data].available_datas.length > 0) {
				return true;
			}
		}
		return false;
	}
	moveStepTo= (step)=>{
		this.props.forceStep(step);
	}


	init_recap = function (demandeur, enfants, conjoint, logement, ressources) {
		
		
		const date = new Date();
		const year = date.getFullYear();
		const {step, individus, famille, foyer_fiscal, menage} = this.props;
		const _conjoint = this.props.conjoint;
		const individu = this.props.demandeur;

		var thisMonth = year + '-' + ('0' + (date.getMonth() + 1)).slice(-2);
		// recapitulatif demandeur
		var nombre_enfant = Object.keys(individus).length;

		if (individu !== undefined && individu.age) {
			// age
			var data_age = <>Ag&eacute;.e de <span className='bold'>{individu.age }</span> an.s</>;

			demandeur.push(data_age);

			// nationalite
			var data_nat = this.get_nationalite_individu(individu);
			demandeur.push(data_nat);
			

			// situation specifique
			var data_situation = this.get_situation_individu(individu);
			if (data_situation !== '') demandeur.push(data_situation);

			// statut marital
			var data_statut_marital = this.get_statut_marital(famille,_conjoint,individu);

			// Precision sur situation familliale
			var data_famille = data_statut_marital;

			if (nombre_enfant) {
				let data_enfants = nombre_enfant + ' enfant(s)';
				data_famille = data_famille === '' ? data_enfants : data_famille + '/' + data_enfants;
			}

			data_famille = data_famille !== '' ? <span className='bold'>{data_famille}</span> : '';//

			if (data_famille !== '') {
				demandeur.push(data_famille);
			}
		}

		// recapitulatif enfant
		if (nombre_enfant > 0) {
			let nb_enfant = <p> {nombre_enfant} enfant.s à charge </p>;//

			enfants.push(nb_enfant);

			Object.keys(individus).forEach((enf_id)=>{
				let enfant = individus[enf_id];

				let data_enfant = <><span className='bold'> {enfant.name }</span> {enfant.age} an.s {enfant.garde_alternee ? ", garde alternée" :""}</>;

				enfants.push(data_enfant);
			});
		}

		// recapitulatif conjoint
		if (famille.en_couple && typeof _conjoint !== 'undefined') {
			let stat_marital_conj, nat_conj, situation_conj;

			let conj_age = <>Ag&eacute;.e de <span className='bold'>{_conjoint.age }</span> an.s</>;//
			conjoint.push(conj_age);

			nat_conj = this.get_nationalite_individu(_conjoint);
			conjoint.push(nat_conj);

			situation_conj = this.get_situation_individu(_conjoint);
			if (situation_conj !== '') conjoint.push(situation_conj);

			stat_marital_conj = <span className='bold'> {this.get_statut_marital(famille,_conjoint,individu)}</span>;//
			conjoint.push(stat_marital_conj);
		}
				// recapitulatif logement
		let logement_valid = menage.statut_occupation_logement && menage.depcom; //
		if (logement_valid) {
			let data_type_logement, data_loyer, data_charge_loc, data_logement_chambre, data_situation_log;
			let is_autre_logement = false;

			data_situation_log = menage.statut_occupation_logement;

			if (data_situation_log === 'locataire_vide') {
				data_loyer = menage.loyer; // loyer
				data_charge_loc = menage.charges_locatives;
				data_logement_chambre = menage.logement_chambre; // logement chambre
				data_situation_log = 'Locataire';
				data_type_logement = 'Non meublé';
			} else if (data_situation_log === 'locataire_meuble') {
				data_loyer = menage.loyer; // loyer
				data_logement_chambre = menage.logement_chambre; // logement chambre
				data_situation_log = 'Locataire';
				data_type_logement = 'Meublé';
			} else if (data_situation_log === 'locataire_foyer') {
				data_loyer = menage.loyer; //loyer
				data_charge_loc = menage.charges_locatives;
				data_situation_log = 'Locataire';
				data_type_logement = 'Foyer';
			} else {
				is_autre_logement = true;
				let autre_situations_logement = {
					primo_accedant: 'Propriétaire (primo accédant)',
					proprietaire: 'Propriétaire',
					sans_domicile: 'Sans domicile',
					non_renseigne: 'Non renseigné',
					loge_gratuitement: 'Héberger'
				};
				data_situation_log = autre_situations_logement[data_situation_log];

				if (typeof data_situation_log !== 'undefined') {
					data_situation_log = <span className='bold'>{ data_situation_log }</span>;
					logement.push(data_situation_log);
					//	charge mensuel proprietaire
					if (typeof menage.loyer !== 'undefined') {
						data_loyer = <p>charges mensuelle <span className='bold'>{menage.loyer} €</span> </p>;
						logement.push(data_loyer);
					}
				}
			}

			if (!is_autre_logement) {
				data_situation_log = <span className='bold'> {data_situation_log} {data_logement_chambre ? '(Chambre)':''}</span>;
				data_type_logement = <span className='bold'>{data_type_logement} </span>;
				data_loyer = <>Loyer <span className='bold'>{data_loyer }€</span></>;

				logement.push(data_situation_log);
				logement.push(data_type_logement);
				logement.push(data_loyer);

				if (data_charge_loc) {
					data_charge_loc = <>Charge locatives <span className='bold'>{data_charge_loc }€</span></>;
					logement.push(data_charge_loc);
				}
			}
		}
		
		// recapitulatif ressources
		let ressources_valid = typeof individu.ressources !== 'undefined';
		if (ressources_valid) {
			
			
			// Ressources demandeur .

			if (individu && individu.ressources) {
				ressources.push(<p className='sub-title'>Vos Ressources</p>);
				let ressources_personne = individu.ressources;

				for (let ress_id in ressources_personne) {
					this.add_ressource_to_recap(ressources , ressources_personne , ress_id  );
				}
			}
			// Ressources conjoint .
			if (_conjoint && _conjoint.ressources) {
				ressources.push(<p className='sub-title'>Ressources Conjoint</p>);
				let ressources_personne = _conjoint.ressources;

				for (let ress_id in ressources_personne) {
					this.add_ressource_to_recap(ressources , ressources_personne , ress_id);
				}
			}

			// Ressources enfants .
			const liste_enfant_ayant_ressources = Object.keys(individus).filter((id)=>{
				if ( typeof individus[id].ressources !== undefined){
					return id;
				}
				return false;
			});
			if (liste_enfant_ayant_ressources.length > 0) {
				for (let n = 0; n < liste_enfant_ayant_ressources.length; n++) {
					let enfant_id = liste_enfant_ayant_ressources[n];
					let enfant = individus[enfant_id];

					if (enfant && enfant.ressources) {
						ressources.push(<p className='sub-title'>Ressources de	{enfant.name.toLowerCase()} </p>);
						let ressources_personne = enfant.ressources;

						for (let ress_id in ressources_personne) {
							this.add_ressource_to_recap(ressources , ressources_personne , ress_id);
						}
					}
				}
			}
		}	

	}

	componentDidUpdate(){
		Object.keys(this.state.recapitulation_datas).forEach ((type_data)=>{
			this.state.recapitulation_datas[type_data].available_datas = [];
		});
	

		var demandeur = this.state.recapitulation_datas.demandeur.available_datas;
		var enfants = this.state.recapitulation_datas.enfants.available_datas;
		var conjoint = this.state.recapitulation_datas.conjoint.available_datas;
		var logement = this.state.recapitulation_datas.logement.available_datas;
		var ressources = this.state.recapitulation_datas.ressources.available_datas;

		this.init_recap(demandeur, enfants, conjoint, logement, ressources);
	}
	render(){
		
		return <div className="recap">
			<div className="illustration"></div>
			<div className="recap-head" onClick={this.showRecap}>
				<h3>Récapitulatif <span className="fa fa-chevron-up"></span></h3>
			</div>
			{(this.state.displayRecap ) ? 
			<div className="recap-body">
					{!this.hasData() ?
						<div	className="no-data">Aucune donnée saisie. </div>
					: Object.keys(this.state.recapitulation_datas).map((typeData)=>{
						const recap = this.state.recapitulation_datas[typeData];
						if ( recap.available_datas.length >0 )
							return <div className="recap-info" >
									<p className="title">{recap.title}</p>
									<div className="datas">
										{recap.available_datas.map((data)=>(<>{data} <br/></>))}
									</div>
									<div className="change-container">
										<div className="edit-btn" onClick={(e)=>(this.moveStepTo(recap.step))}>
											<span><i className="fa fa-pencil"></i>&nbsp;Modifier</span>
										</div>
									</div>
								</div>;
					})
					}
			</div> : ''}

		</div>
	}

}

export default Recapitulation;